import axios from 'axios';

const portalAxios = axios.create({
	baseURL: process.env.REACT_APP_PORTAL_URL,
});
export default portalAxios;
